export default function ArrowUpCircle({ width = '14', height = '14' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
    >
      <g
        id="Group_15122"
        data-name="Group 15122"
        transform="translate(-1041 -848.646)"
      >
        <circle
          id="Ellipse_2205"
          data-name="Ellipse 2205"
          cx="7"
          cy="7"
          r="7"
          transform="translate(1041 848.646)"
          fill="#013D59"
        />
        <g
          id="_007-up-arrow-1"
          data-name="007-up-arrow-1"
          transform="translate(1044.639 851.729)"
        >
          <g id="Group_2199" data-name="Group 2199">
            <path
              id="Path_5452"
              data-name="Path 5452"
              d="M41.519,4.16,38.237.022a.063.063,0,0,0-.1,0L34.853,4.168a.061.061,0,0,0,.048.1h1.215V7.744a.065.065,0,0,0,.066.06H40.2a.058.058,0,0,0,.059-.06V4.267h1.214a.061.061,0,0,0,.041-.107Z"
              transform="translate(-34.84)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
